import CursorIcon from '../icons/CursorIcon'
import { RootReducer } from '../redux/rootReducer'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
type Props = {}

const Cursor = (props: Props) => {
  const { cursorPosition } = useSelector((state: RootReducer) => state.slidesReducer)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    //initial render
    if (cursorPosition.x === 0 && cursorPosition.y === 0) return
    setIsVisible(true)
    if (timeoutRef.current) clearTimeout(timeoutRef.current)

    timeoutRef.current = setTimeout(() => {
      setIsVisible(false)
    }, 2000)

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [cursorPosition])

  if (!isVisible) return <></>

  return (
    <div style={{ left: cursorPosition.x, top: cursorPosition.y }} className="absolute flex pointer-events-none">
      <div className="w-10 h-10 ml-[-9px] mt-[-3px] text-slateGray">
        <CursorIcon />
      </div>
    </div>
  )
}

export default Cursor
